/**
 * Read per-tag AI spend from the LiteLLM proxy's daily aggregates.
 *
 * Shared by the ERP backend (env-scoped, its own virtual key) and the control plane
 * (all environments, the master key). Both surfaces show money, so the parsing lives
 * here once rather than being reimplemented — a divergence between them would mean one
 * of the two is quietly wrong.
 */
export {
  collectRankedTagSpend,
  collectTagDetails,
  collectTagUsage,
  collectTeamUsage,
  notConfiguredTagUsage,
  type CollectOptions,
  type CollectRankedTagSpendOptions,
  type CollectTagDetailsOptions,
  type CollectTeamUsageOptions,
  type FetchLike,
} from "./collect";
export {
  addDays,
  daysBetween,
  defaultWindow,
  isDateOnly,
  toDateOnly,
  todayUtc,
  type DateOnly,
} from "./dates";
export { buildNamespaces, emptyNamespaces } from "./namespaces";
export {
  emptyMetrics,
  parseTagDailyActivity,
  parseTagList,
  parseTagSpendByEntity,
  parseTeamDailyActivity,
  sumMetrics,
  totalPages,
} from "./parse";
export {
  groupTagsByNamespace,
  isKnownTag,
  parseTag,
  splitKeyAlias,
  USAGE_TAG_NAMESPACES,
  type GroupedTags,
  type ParsedTag,
} from "./tags";
export type {
  AvailableUsageDimensions,
  DenominatorSource,
  KeyOrigin,
  RankedTagSpend,
  RankedTagSpendResult,
  TagDetailsResult,
  TagNamespaceUsage,
  TagUsage,
  TagUsageRow,
  TeamUsage,
  TeamWindowUsage,
  UsageDay,
  UsageDimensionRow,
  UsageMetrics,
} from "./types";
